import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { IAssetModelSettingsDto } from '~/models/modules/Asset/assetModelSettings';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class AssetModelSettingsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminAssets);
  }
  getassetModelSettings() {
    return this.http.get<IAssetModelSettingsDto>(this._url());
}

updateAssetModelSettings(model: any) {
    return this.client.put(this._url(), model);
}

private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AssetModelSettings${v}`);
}

}
